export default [
    {
      path: '/create-word',
      component: () => import('./views/Index'),
      name: 'create-word',
      redirect: { name: 'create-word-list' },
      children: [
        {
          path: '',
          name: 'create-word-list',
          component: () => import('./views/List'),
          meta: {
            resource: 'auth',
          },
        },
        {
          path: ':id',
          name: 'create-word-detail',
          component: () => import('./views/Detail'),
          meta: {
            resource: 'auth',
          },
        },
      ],
    },
  ]
  